import * as React from 'react';
import * as classNames from 'classnames';
import { theme } from './theme';


export function MarkdownToolbarButton({ children, className, disabled, actived, onClick }) {
	return (
		<div className={theme.buttonWrapper}>
			<button
				className={classNames(theme.button, { actived, disabled })}
				onClick={onClick}>
				{ children }
			</button>
		</div>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/toolbar/MarkdownToolbarButton.jsx